import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-edit-medicine-information',
  imports: [CommonModule, FormsModule],
  templateUrl: './edit-medicine-information.component.html',
  styleUrl: './edit-medicine-information.component.css'
})
export class EditMedicineInformationComponent {
  @Output() openEditMedInfoModal = new EventEmitter<boolean>();
  @Output() saveChanges = new EventEmitter<void>();
  @Input() medicineData: any;

  editedMedicineData: any;

  public optionsAreaTerapeutica = [
    'Anesthesiology',
    'Cardiology',
    'Critical Care Medicine',
    'Dermatology',
    'Endocrinology & Metabolism',
    'Gastroenterology',
    'Geriatrics',
    'Gynecology & Obstetrics',
    'Hematology',
    'Immunology & Allergy',
    'Infectious Diseases',
    'Nephrology',
    'Neurology',
    'Nuclear Medicine',
    'Oncology',
    'Ophthalmology',
    'Orthopedics',
    'Otolaryngology',
    'Physical Medicine & Rehabilitation',
    'Preventive Medicine',
    'Psychiatry',
    'Pulmonology',
    'Radiology',
    'Rheumatology',
    'Rare Disease',
    'Surgery',
    'Urology'
  ];

  public optionsClasseRimborsabilita = [
    'A',
    'A-PHT',
    'H',
    'C'
  ];

  public optionsClasseFornitura = [
    'RR',
    'RNR',
    'RRL',
    'RNRL',
    'RMS',
    'OSP',
    'OSPL',
    'USPL',
    'OTC',
    'SOP'
  ];

  public optionsTipologiaAccesso = [
    'Nuovo Prodotto Classe H',
    'Nuovo Prodotto Classe A-PHT',
    'Nuovo Prodotto Orfano'
  ];

  public accessTypeMap: { [key: string]: string } = {
    'Nuovo Prodotto Classe H': 'H',
    'Nuovo Prodotto Classe A-PHT': 'A-PHT',
    'Nuovo Prodotto Orfano': 'Orfano'
  };

  ngOnInit (): void {
    console.log("original", this.medicineData);
    this.editedMedicineData = { ...this.medicineData };
  }

  onSaveChanges () {
    console.log("edited", this.editedMedicineData);

    this.saveChanges.emit(this.editedMedicineData);
    this.closeModal();
  }


  // CLOSE MODAL
  closeModal () {
    this.openEditMedInfoModal.emit(false);
  }
}
